import { Spinner } from '@cp-shared-10/frontend-ui';
import { ContentSection } from '@vwfs-bronson/bronson-react';
import React from 'react';

export const CenteredSpinner = () => (
    <ContentSection>
        <Spinner center />
    </ContentSection>
);
